import React, { useRef, useState, useEffect } from "react";
import { toast } from 'react-toastify';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import emailjs from '@emailjs/browser';
import Slider from "../components/Slider" ;
// PDF generation imports
import jsPDF from 'jspdf';
import DuckmanLogo from '../assets/images/duckmanalogo.png'; // Company logo, imported as base64
import {ref as storageRef, uploadBytes } from "firebase/storage";
import { storage } from '../Firebase'; // Firebase storage instance
import Cart from '../components/Cart';
import { useLocation } from 'react-router-dom';

const Book = ({ bookedVehicles, setBookedVehicles, showCart, setShowCart }) => {
  const form = useRef();
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [currentVehicle, setCurrentVehicle] = useState({ // State for the car currently being configured
    model: '',
    type: '',
    packages: []
  });
  const location = useLocation();

  useEffect(() => {
    if (location.state?.openCart) {
      setShowCart(true);
    }
  }, [location.state, setShowCart]);

  const packages = [
    {
      name: "PRESTIGE",
      description: "Interior & Exterior Deep Clean + Engine Steam Detailing / Rim Cleaning",
      prices: { saloon: "KES 8,000", midSuv: "KES 10,000", suv: "KES 11,000" },
      gradient: "linear-gradient(135deg, #059669, #0d9488)",
      popular: true
    },
    {
      name: "MAJESTIC",
      description: "Prestige + Paint Correction/Buffing",
      prices: { saloon: "KES 13,000", midSuv: "KES 15,000", suv: "KES 18,000" },
      gradient: "linear-gradient(135deg, #ea580c, #dc2626)"
    },
    {
      name: "ROYALE",
      description: "Majestic + Premium Additional Services",
      prices: { saloon: "KES 26,000", midSuv: "KES 29,000", suv: "KES 31,500" },
      gradient: "linear-gradient(135deg, #9333ea, #ec4899)",
      premium: true
    }
  ];


  
  const sendEmail = (e) => {
    e.preventDefault();

    console.log('bookedVehicles at start of sendEmail:', bookedVehicles);

    const formData = new FormData(form.current);
    
    // Validation for personal details and booked vehicles
    const customerName = formData.get('name');
    const customerEmail = formData.get('email');
    const customerTel = formData.get('tel');
    const customerLocation = formData.get('location');
    const additionalMessage = formData.get('message'); // Get additional message

    if (!customerName || !customerEmail || !customerTel || !customerLocation) {
      toast.error("Please fill in all your personal details.");
      return;
    }
    if (bookedVehicles.length === 0) {
      toast.error("Please add at least one vehicle to your booking.");
      return;
    }

    // Generate a formatted string for all vehicles
    const vehiclesSummary = bookedVehicles.map((vehicle, index) => {
      const vehicleDetails = `Vehicle ${index + 1}: ${vehicle.model} (${vehicle.type})`;
      const packageDetails = `Packages: ${vehicle.packages.join(', ')}`;
      const price = calculateTotalPrice([vehicle]); // Calculate price per vehicle
      return `${vehicleDetails}\n${packageDetails}\nPrice: KES ${price.toLocaleString()}`;
    }).join('\n\n'); // Separate each vehicle with double newline

    const emailData = {
      name: customerName,
      email: customerEmail,
      tel: customerTel,
      location: customerLocation,
      message: additionalMessage, // Use additionalMessage
      vehiclesSummary: vehiclesSummary, // New field for summary of all vehicles
      totalAmount: calculateTotalPrice(bookedVehicles).toLocaleString(), // Total amount for all vehicles
    };

    console.log('Sending email with data:', emailData);

    emailjs
      .send('service_zghvd7o', 'template_e7haqof', emailData, '92DMt1KF5hIM7h7ga')
      .then(
        (result) => {
          console.log(result.text);
          setIsFormSubmitted(true);
          toast.success("Booking has been sent successfully!");
          form.current.reset();
          setBookedVehicles([]); // Reset all booked vehicles
          setCurrentVehicle({ model: '', type: '', packages: [] }); // Reset current vehicle
          setShowCart(false); 
        },
        (error) => {
          console.log(error.text);
          toast.error('Failed to submit booking. Please try again.');
        }
      );
  };

  const getSelectedPrice = (pkg, vehicleType) => {
    if (!vehicleType) return '';
    return pkg.prices[vehicleType];
  };

  const calculateTotalPrice = (vehicles) => {
    let total = 0;
    console.log("Starting calculateTotalPrice for vehicles:", vehicles);
    vehicles.forEach(vehicle => {
      console.log("  Processing vehicle:", vehicle.model, vehicle.type);
      vehicle.packages.forEach(pkgName => {
        const pkg = packages.find(p => p.name === pkgName);
        if (pkg && pkg.prices[vehicle.type]) {
          const price = pkg.prices[vehicle.type];
          const priceValue = parseInt(price.replace('KES ', '').replace(',', ''));
          total += priceValue;
          console.log(`    Package: ${pkgName}, Price string: ${price}, Parsed value: ${priceValue}, Running total: ${total}`);
        } else {
            console.log(`    Package: ${pkgName} not found or price for type ${vehicle.type} is missing.`);
        }
      });
    });
    console.log("Final calculated total:", total);
    return total;
  };

  const generateAndUploadInvoice = async () => {

    // 1. Gather data

    const formData = new FormData(form.current);

    const customerName = formData.get('name');

    const customerEmail = formData.get('email');

    const customerTel = formData.get('tel');

    const customerLocation = formData.get('location');

    const additionalMessage = formData.get('message');



    // Basic validation

    if (!customerName || !customerEmail || !customerTel || !customerLocation) {

      toast.error("Please fill in all your personal details.");

      return;

    }

    if (bookedVehicles.length === 0) {

      toast.error("Please add at least one vehicle to your booking.");

      return;

    }



    toast.info("Generating invoice...");

    try {

      const doc = new jsPDF();

      const getLogoDimensions = () => new Promise((resolve, reject) => {
        const img = new Image();
        img.src = DuckmanLogo;
        img.onload = () => {
          resolve({ width: img.width, height: img.height });
        };
        img.onerror = (err) => {
            console.error("Error loading logo for PDF:", err);
            reject(err);
        };
      });



      const { width, height } = await getLogoDimensions();

      const logoAspectRatio = width / height;

      const pdfLogoWidth = 40;

      const pdfLogoHeight = pdfLogoWidth / logoAspectRatio;

      doc.addImage(DuckmanLogo, 'PNG', 150, 10, pdfLogoWidth, pdfLogoHeight);



      // Company Info

      doc.setFontSize(20);

      doc.setFont('helvetica', 'bold');
      doc.text("Duckman Auto Detailing", 14, 20);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.setTextColor("#555555");
      doc.text("Nairobi, Kenya", 14, 28);
      doc.text("+254702982035 | info@duckmanautodetailing.com", 14, 34);



      // Invoice Details
      const invoiceDate = new Date().toLocaleDateString('en-GB');
      const invoiceNumber = `INV-${new Date().getTime()}`;
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.text(`Invoice #${invoiceNumber}`, 14, 50);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(12);
      doc.text(`Date: ${invoiceDate}`, 14, 58);



      // Customer Details
      doc.setFontSize(14);
      doc.setFont('helvetica', 'bold');
      doc.text("Bill To:", 14, 70);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(12);
      doc.setTextColor("#555555");
      doc.text(`Name: ${customerName}`, 14, 78);
      doc.text(`Email: ${customerEmail}`, 14, 86);
      doc.text(`Phone: ${customerTel}`, 14, 94);
      doc.text(`Location: ${customerLocation}`, 14, 102);



      let currentY = 115;
      doc.setFontSize(14);
      doc.setFont('helvetica', 'bold');
      doc.text("Booking Details:", 14, currentY);
      doc.setFont('helvetica', 'normal');
      currentY += 10;



      const overallTotalAmount = calculateTotalPrice(bookedVehicles);



      bookedVehicles.forEach((vehicle, index) => {
        const vehicleTotalPrice = calculateTotalPrice([vehicle]);

        

        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.text(`Vehicle ${index + 1}: ${vehicle.model} (${vehicle.type})`, 14, currentY);
        doc.setFont('helvetica', 'normal');
        currentY += 8;



        doc.setFontSize(12);
        doc.setTextColor("#555555");
        doc.text(`  Packages: ${vehicle.packages.join(', ')}`, 14, currentY);
        currentY += 8;



        doc.setFontSize(12);
        doc.setTextColor("#333333");
        doc.text(`  Subtotal: KES ${vehicleTotalPrice.toLocaleString()}`, 14, currentY);
        currentY += 12;
      });



      if (additionalMessage) {
        doc.setFontSize(12);
        doc.setTextColor("#555555");
        doc.text(`Additional Info: ${additionalMessage}`, 14, currentY);
        currentY += 10;
      }

      

      currentY += 10;



      // Overall Total Amount
      doc.setFontSize(16);
      doc.setFont('helvetica', 'bold');
      doc.text(`Total Amount: KES ${overallTotalAmount.toLocaleString()}`, 14, currentY);
      doc.setFont('helvetica', 'normal');

      currentY += 16;



      // Thank You Message

      doc.setFontSize(10);

      doc.setTextColor("#555555");

      doc.text("Thank you for choosing Duckman Auto Detailing!", 14, currentY + 20);

      doc.text("For any queries, please contact us at 0702982035", 14, currentY + 26);



      // Footer

      doc.setFontSize(10);

      doc.setTextColor("#555555");

      doc.text("keep it clean keep it shinny", 14, doc.internal.pageSize.height - 10);



      const pdfBlob = doc.output('blob');



      const customerSafeName = customerName.replace(/[^a-z0-9]/gi, '_').toLowerCase();

      const fileName = `${customerSafeName}_${new Date().getTime()}.pdf`;

      const invoicesRef = storageRef(storage, `invoices/${fileName}`);



      await uploadBytes(invoicesRef, pdfBlob);





      toast.success("Invoice generated and uploaded! Download starting...");

      

                const url = URL.createObjectURL(pdfBlob);

      

                const a = document.createElement('a');

      

                a.href = url;

      

                a.download = fileName;

      

                document.body.appendChild(a);

      

                a.click();

      

                document.body.removeChild(a);

      

                URL.revokeObjectURL(url); // Clean up

    } catch (error) {

      console.error("Error generating or uploading PDF:", error);

      toast.error("Failed to generate or upload invoice. Please try again.");

    } finally {

    }
  }; // Close generateAndUploadInvoice
  
  const handleAddToCart = (pkg) => {
    const formData = new FormData(form.current);
    const errors = {};

    if (!formData.get('name')) errors.name = "Name is required";
    if (!formData.get('email')) errors.email = "Email is required";
    if (!formData.get('tel')) errors.tel = "Phone number is required";
    if (!formData.get('location')) errors.location = "Location is required";
    if (!currentVehicle.model) errors.model = "Vehicle model is required";
    if (!currentVehicle.type) errors.type = "Vehicle type is required";

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      if (errors.name || errors.email || errors.tel || errors.location) {
        form.current.scrollIntoView({ behavior: 'smooth' });
      }
      return;
    }

    setFormErrors({}); // Clear errors
    const newVehicle = {
      ...currentVehicle,
      packages: [pkg.name],
      id: Date.now()
    };

    setBookedVehicles(prev => [...prev, newVehicle]);
    toast.success(`${pkg.name} added to cart!`);
    setCurrentVehicle({ model: '', type: '', packages: [] }); // Reset for next car
  };

  const handleRemoveFromCart = (idToRemove) => {
    setBookedVehicles(prev => prev.filter(vehicle => vehicle.id !== idToRemove));
    toast.info("Vehicle removed from cart.");
  };

  const handleBookNow = () => {
    const formData = new FormData(form.current);
    const customerName = formData.get('name');
    const customerEmail = formData.get('email');
    const customerTel = formData.get('tel');
    const customerLocation = formData.get('location');

    if (!customerName || !customerEmail || !customerTel || !customerLocation) {
      toast.error("Please fill in all your personal details before booking.");
      setShowCart(false);
      form.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      sendEmail({ preventDefault: () => {} }); // Mock event object
    }
  };

  return (
    <div 
      className="min-h-screen w-full"
      style={{
        background: "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)"
      }}
    >
      <Slider />

      {showCart && (
        <Cart
          bookedVehicles={bookedVehicles}
          onRemove={handleRemoveFromCart}
          onPrint={generateAndUploadInvoice}
          onBook={handleBookNow}
          onClose={() => setShowCart(false)}
          calculateTotalPrice={calculateTotalPrice}
          packages={packages}
        />
      )}

      <div className="w-full px-4 md:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-[1400px] mx-auto items-start">
          
          {/* Contact Information Section */}
       

          {/* Booking Form Section */}
          <div className="backdrop-blur-xl bg-white/10 border border-white/20 rounded-3xl p-8 hover:bg-white/15 transition-all duration-500 w-full md:order-2">
            <div className="text-center mb-8">
              <h3 
                className="text-3xl font-bold mb-4"
                style={{
                  background: "linear-gradient(135deg, #ffffff, #e2e8f0)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent"
                }}
              >
                Book Your Service
              </h3>
              <div 
                className="w-16 h-1 mx-auto rounded-full"
                style={{background: "linear-gradient(90deg, #9333ea, #ec4899)"}}
              ></div>
            </div>

            {isFormSubmitted ? (
              <div className="text-center py-12">
                <div 
                  className="w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-6"
                  style={{background: "linear-gradient(135deg, #10b981, #059669)"}}
                >
                  <CheckCircleIcon style={{fontSize: 48, color: 'white'}} />
                </div>
                <h4 className="text-2xl font-bold text-white mb-2">Thank You!</h4>
                <p className="text-white text-lg">Your booking has been received. We'll contact you shortly.</p>
              </div>
            ) : (
              <form ref={form} onSubmit={sendEmail} className="space-y-6">
                
                {/* Personal Information */}
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <input
                      required
                      type="text"
                      placeholder="Your Name"
                      name="name"
                      className={`w-full bg-white/10 backdrop-blur border ${formErrors.name ? 'border-red-500' : 'border-white/20'} rounded-2xl h-14 px-6 text-white placeholder-gray-400 outline-none focus:border-blue-400 focus:bg-white/15 transition-all duration-300`}
                    />
                    {formErrors.name && <p style={{ color: '#ef4444' }} className="text-xs mt-1 ml-2 font-bold">{formErrors.name}</p>}
                  </div>
                  <div>
                    <input
                      required
                      type="email"
                      placeholder="Your Email"
                      name="email"
                      className={`w-full bg-white/10 backdrop-blur border ${formErrors.email ? 'border-red-500' : 'border-white/20'} rounded-2xl h-14 px-6 text-white placeholder-gray-400 outline-none focus:border-blue-400 focus:bg-white/15 transition-all duration-300`}
                    />
                    {formErrors.email && <p style={{ color: '#ef4444' }} className="text-xs mt-1 ml-2 font-bold">{formErrors.email}</p>}
                  </div>
                </div>


                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <input
                      required
                      type="tel"
                      placeholder="Phone Number"
                      name="tel"
                      className={`w-full bg-white/10 backdrop-blur border ${formErrors.tel ? 'border-red-500' : 'border-white/20'} rounded-2xl h-14 px-6 text-white placeholder-gray-400 outline-none focus:border-blue-400 focus:bg-white/15 transition-all duration-300`}
                    />
                    {formErrors.tel && <p style={{ color: '#ef4444' }} className="text-xs mt-1 ml-2 font-bold">{formErrors.tel}</p>}
                  </div>
                  <div>
                    <input
                      required
                      type="text"
                      placeholder="Location"
                      name="location"
                      className={`w-full bg-white/10 backdrop-blur border ${formErrors.location ? 'border-red-500' : 'border-white/20'} rounded-2xl h-14 px-6 text-white placeholder-gray-400 outline-none focus:border-blue-400 focus:bg-white/15 transition-all duration-300`}
                    />
                    {formErrors.location && <p style={{ color: '#ef4444' }} className="text-xs mt-1 ml-2 font-bold">{formErrors.location}</p>}
                  </div>
                </div>

                <div>
                  <input
                    type="text"
                    placeholder="Vehicle Model (e.g., Toyota Camry 2020)"
                    name="Model"
                    value={currentVehicle.model}
                    onChange={(e) => setCurrentVehicle(prev => ({ ...prev, model: e.target.value }))}
                    className={`w-full bg-white/10 backdrop-blur border ${formErrors.model ? 'border-red-500' : 'border-white/20'} rounded-2xl h-14 px-6 text-white placeholder-gray-400 outline-none focus:border-blue-400 focus:bg-white/15 transition-all duration-300`}
                  />
                  {formErrors.model && <p style={{ color: '#ef4444' }} className="text-xs mt-1 ml-2 font-bold">{formErrors.model}</p>}
                </div>

                {/* Vehicle Type Selection */}
                <div>
                  <h4 className="text-white font-semibold text-lg mb-4">Vehicle Type</h4>
                  <div className="grid grid-cols-3 gap-3">
                    {['saloon', 'midSuv', 'suv'].map((type) => (
                      <button
                        key={type}
                        type="button"
                        onClick={() => setCurrentVehicle(prev => ({ ...prev, type: type }))}
                        className={`p-4 rounded-2xl border-2 transition-all duration-300 ${
                          currentVehicle.type === type
                            ? 'border-blue-400 bg-blue-500/20 text-white'
                            : formErrors.type ? 'border-red-500/50 bg-white/5 text-white' : 'border-white/20 bg-white/5 text-white  hover:border-white/40'
                        }`}
                      >
                        <div className="font-semibold">
                          {type === 'saloon' ? 'Saloon' : type === 'midSuv' ? 'Mid-SUV' : 'SUV'}
                        </div>
                      </button>
                    ))}
                  </div>
                  {formErrors.type && <p style={{ color: '#ef4444' }} className="text-xs mt-2 ml-2 font-bold">{formErrors.type}</p>}
                </div>

                {/* Package Selection */}
                <div>
                  <h4 className="text-white font-semibold text-lg mb-4">Select Package(s)</h4>
                  <div className="space-y-4">
                    {packages.map((pkg, index) => (
                      <div
                        key={index}
                        className={`relative p-6 rounded-2xl border-2 transition-all duration-300 
                          'border-white/20 bg-white/5 hover:border-white/40 hover:bg-white/10'
                        }`}
                      >
                        {pkg.popular && (
                          <div 
                            className="absolute -top-3 left-6 px-3 py-1 rounded-full text-xs font-bold text-white"
                            style={{background: "linear-gradient(135deg, #fbbf24, #f97316)"}}
                          >
                            POPULAR
                          </div>
                        )}
                        {pkg.premium && (
                          <div 
                            className="absolute -top-3 right-6 px-3 py-1 rounded-full text-xs font-bold text-white"
                            style={{background: "linear-gradient(135deg, #9333ea, #ec4899)"}}
                          >
                            PREMIUM
                          </div>
                        )}
                        
                        <div className="flex items-start gap-4">
                          <div className="flex-1">
                            <div className="flex items-center gap-3 mb-2">
                              <h5 
                                className="text-xl font-bold"
                                style={{
                                  background: pkg.gradient,
                                  WebkitBackgroundClip: "text",
                                  WebkitTextFillColor: "transparent"
                                }}
                              >
                                {pkg.name}
                              </h5>
                            </div>
                            <p className="text-white  mb-3">{pkg.description}</p>
                            {currentVehicle.type && ( // Use currentVehicle.type
                              <div 
                                className="inline-block px-4 py-2 rounded-lg text-white font-bold"
                                style={{background: pkg.gradient}}
                              >
                                {getSelectedPrice(pkg, currentVehicle.type)} 
                              </div>
                            )}
                            {!currentVehicle.type && ( // Use currentVehicle.type
                              <div className="text-sm text-white ">
                                <span className="font-medium">Saloon:</span> {pkg.prices.saloon} | 
                                <span className="font-medium"> Mid-SUV:</span> {pkg.prices.midSuv} | 
                                <span className="font-medium"> SUV:</span> {pkg.prices.suv}
                              </div>
                            )}
                          </div>
                        </div>
                        <button
                          type="button"
                          onClick={() => handleAddToCart(pkg)}
                          className="w-full mt-4 h-12 rounded-2xl text-white font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
                          style={{background: "linear-gradient(135deg, #3b82f6, #1d4ed8)"}}
                        >
                          Add to Cart
                        </button>
                      </div>
                    ))}
                  </div>
                </div>

                <textarea
                  name="message"
                  placeholder="Additional Information or Special Requests"
                  rows={4}
                  className="w-full bg-white/10 backdrop-blur border border-white/20 rounded-2xl p-6 text-white placeholder-gray-400 outline-none focus:border-blue-400 focus:bg-white/15 transition-all duration-300 resize-none"
                />
              </form>
            )}
          </div>
          <div className="backdrop-blur-xl h-auto bg-white/10 border border-white/20 rounded-3xl p-8 hover:bg-white/15 transition-all duration-500 md:order-1">
            <div className="text-center mb-8">
              <h3 
                className="text-3xl font-bold mb-4"
                style={{
                  background: "linear-gradient(135deg, #ffffff, #e2e8f0)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent"
                }}
              >
                Get In Touch
              </h3>
              <div 
                className="w-16 h-1 mx-auto rounded-full mb-6"
                style={{background: "linear-gradient(90deg, #059669, #0d9488)"}}
              ></div>
              <p className="text-white text-lg leading-relaxed max-w-md mx-auto">
                At Duckman Auto Detailing, we take pride in each project we undertake. From protection to restoration, your car is in expert hands.
              </p>
            </div>

            <div className="space-y-6 mb-8">
              <div className="flex items-center gap-4 p-4 rounded-2xl bg-white/5 backdrop-blur">
                <div className="w-12 h-12 rounded-full bg-red-500/20 flex items-center justify-center">
                  <LocationOnIcon className="text-red-500" />
                </div>
                <span className="text-white text-base">Nairobi, Kenya</span>
              </div>
              
              <div className="flex items-center gap-4 p-4 rounded-2xl bg-white/5 backdrop-blur">
                <div className="w-12 h-12 rounded-full  text-green-400  bg-green-500/20 flex items-center justify-center">
                  <WhatsAppIcon className="text-green-400 " />
                </div>
                <span className="text-white text-base">+254702982035</span>
              </div>
              
              <div className="flex items-center gap-4 p-4 rounded-2xl bg-white/5 backdrop-blur">
                <div className="w-12 h-12 rounded-full bg-blue-500/20 flex items-center justify-center">
                  <EmailIcon className="text-blue-400" />
                </div>
                <span className="text-white text-base">info@duckmanautodetailing.com</span>
              </div>
            </div>

            <div className="flex justify-center gap-4">
              {[
                { Icon: FacebookIcon, href: "https://www.facebook.com/profile.php?id=100086023751331", color: "#4267B2" },
                { Icon: TwitterIcon, href: "https://twitter.com/DuckmanAuto", color: "#1DA1F2" },
                { Icon: InstagramIcon, href: "https://www.instagram.com/duckmanautodetailing", color: "#E1306C" }
              ].map(({ Icon, href, color }, index) => (
                <a 
                  key={index}
                  href={href}
                  className="w-12 h-12 rounded-full backdrop-blur bg-white/10 flex items-center justify-center hover:scale-110 transition-all duration-300"
                  style={{"--hover-color": color}}
                >
                  <Icon style={{color}} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      </div>

  );
};

export default Book;